import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';

import { withStyles, createStyles, WithStyles, makeStyles, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import SchedulePeriodRow from './SchedulePeriodRow';
import BookingPeriodRow from './BookingPeriodRow';
import {
  IFreeDay, IRestaurantWorkTimes,
  IScheduleRow, TScheduleFieldType,
  TWeekDay,
} from '../../../types/IScheduleStore';
import locales from '../../../locales';
import { useDispatch, useSelector } from "react-redux";
import { addNewScheduleRow, deleteScheduleRow, updateFreeDays, updateSchedule } from "../../../actions/schedules/SchedulesAction";
import { makeGetFreeDays, makeGetScheduleRows } from "./selectors";

const useStyles = makeStyles((theme) => createStyles({
  wrap: {
    padding: '12px 0',
  },
  marginButton: {
    paddingBottom: 12,
  },
  subtitle: {
    lineHeight: '30px',
    marginTop: '32px',
    marginBottom: '24px',

    [theme.breakpoints.down(600)]: {
      marginTop: 0
    },
  },
}));

interface IProps {
  label?: string;
  restaurantWorkTimes?: IRestaurantWorkTimes; // Необходим только для расписания приёма автоброни
  type: TScheduleFieldType;
}

type IHandleUpdateFreeDays = (days: {
  activate: Array<TWeekDay>,
  deactivate: Array<TWeekDay>
}) => void;

type IHandelChangeSchedule = (row: IScheduleRow) => void;

// TODO Переделать лейбл у компонента, у дефолтного InputLabel не корректные шрифты и паддинги
const ScheduleTableComp: React.FC<IProps> = (props) => {
  const {
    label,
    restaurantWorkTimes,
    type
  } = props;

  const classes = useStyles()

  const dispatch = useDispatch();

  const scheduleList: Array<IScheduleRow> = useSelector(useMemo(() => makeGetScheduleRows(type), [type]));
  const freeDays: Array<IFreeDay> = useSelector(useMemo(() => makeGetFreeDays(type), [type]));

  /** @description Ручка для изменения свободных дней в расписании */
  const handleUpdateFreeDays: IHandleUpdateFreeDays = useCallback((days) => {
    dispatch(updateFreeDays(days, type))
  }, [dispatch, type])

  /** @description Ручка экшена для редактирования строки расписания */
  const handelUpdateSchedule: IHandelChangeSchedule = useCallback((row) => {
    dispatch(updateSchedule(row, type))
  }, [dispatch, type])

  /** @description Ручка экшена для удаления строки расписания */
  const handleDeleteScheduleRow: IHandelChangeSchedule = useCallback((row) => {
    dispatch(deleteScheduleRow(row, type))
  }, [dispatch, type])

  /** @description Ручка экшена для добавления новой строки в расписание */
  const handleAddScheduleRow: VoidFunction = useCallback(() => {
    dispatch(addNewScheduleRow(type))
  }, [dispatch, type])


  return (
    <div className={classes.wrap}>
      <div className={classNames({ [classes.marginButton]: !!label })}>
        {!!label && <Typography variant="h6" className={classes.subtitle}>{label}</Typography>}
        {
          scheduleList.map(schedule => (
            restaurantWorkTimes ? (
              <BookingPeriodRow
                key={schedule.id}
                handelUpdateSchedule={handelUpdateSchedule}
                handleDeleteScheduleRow={handleDeleteScheduleRow}
                handleUpdateFreeDays={handleUpdateFreeDays}
                schedule={schedule}
                freeDays={freeDays}
                restaurantWorkTimes={restaurantWorkTimes}
              />
            ) : (
              <SchedulePeriodRow
                key={schedule.id}
                handelUpdateSchedule={handelUpdateSchedule}
                handleDeleteScheduleRow={handleDeleteScheduleRow}
                handleUpdateFreeDays={handleUpdateFreeDays}
                schedule={schedule}
                freeDays={freeDays}
              />
            )
          ))
        }
      </div>
      <Button
        onClick={handleAddScheduleRow}
        color="primary"
        variant="contained"
      >
        {locales.t('reservesSystem.basicInformation.addNewSchedule')}
      </Button>
    </div>
  );
};

export default ScheduleTableComp;
